
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mobiworkx/profile",
      function () {
        return require("private-next-pages/mobiworkx/profile.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mobiworkx/profile"])
      });
    }
  